import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
export default {
    allTitle: {
        moreBtn: '查看更多...',
        outBtn: '退出登录',
        accountBtn: '账号管理',
        switchBtn: '切换工厂'
    },
    leftNav: {
        navfoot: "赛象云工业互联网提供技术支持",
        navTitle: '赛象云工业互联网',
        ptnavTitle: '中策半钢成型车间设备物联网',
        navOne: '主页',
        navTwo: '工厂',
        navThree: '设备仪表板',
        navFour: '设备步序分析',
        navFive: '运行时间记录',
        navSix: '班次记录',
        navSeven: '故障报警',
        navSeven1: '设备故障报警',
        navSeven2: '部件故障报警',
        navEight: '收藏夹',
        navNine: '事件甘特图',
        navTen: '产量分析',
        navEleven: '单胎步序分析',
        navTwelve: '节拍时间分布',
        navThirteen: '换料统计',
        navFourteen: '模拟量数值分析',
        navfiveteen: '单设备换料统计',
        navSixteenth: '产能预测',
        navSeventeenth: '实验室',
        navSeventeenth1: '节拍时间分布',
        navSeventeenth2: '换料统计',
        navSeventeenth3: '单设备换料统计',
        navSeventeenth4: '设备详细步序报告',
        navSeventeenth5: '产能预测',
        navSeventeenth6: '模拟量分析',
        navEighteenth: '设备步序统计报表',
        navnineteen: '车间仪表板',
        navtwentieth: '设备分时信息',
        navTwentyOne: '模拟量图表速览',
        navTwentyTwo: '设备稼动率',
        navTwentyThree: '设备详细步序报告',
        navTwentyFour: '工具箱',
        navTwentyFive: '设备平均效率对比',
        navTwentySix: '当前工艺参数对比',
        navTwentySeven: '工艺参数记录',
        navTwentyEight: '偏置参数记录',
        navTwentyNine:'纠偏数据',
        nav20: '3d模型',
        platform: '大屏',
        nav21: '自助仪表盘',
        nav22: '半制品质量',
        nav23: '账号管理',
        nav24: '事件甘特图V2',
        nav25: '设备综合信息',
        nav26: '日产量分析',
        nav27: '周产量分析',
        nav28: '月产量分析',
        nav29: '半制品质量数据报表',
        nav30: '车间报警统计',
        nav31: '设备规格信息',
        nav32: '轮胎信息',
        nav33: '车间故障统计',
        nav34: '半制品质量数据跟踪',
        nav35: '模拟量数据监控',
        nav36: '设备平均效率对比',
        nav37: '参数管理',
        nav38: '模拟量',
        nav39: '巨胎成型机数字孪生',
        navVpn: 'VPN盒子',
        navVpnApply: 'VPN申请',
        navVpnRewiew: 'VPN审核',
        navVpnAdd: 'VPN管理',
        navVpnInstructions: '使用说明下载',
        navVpnSoft: 'VPN软件下载',

        factoryManage: '工厂管理',
        factory: '工厂',
        shop: '车间',
        line: '产线',
        machineCategory: '设备类型',
        machine: '设备',
        shift: '班组',
        grafana: 'grafana',

        userManage: '用户管理',
        resource: '资源',
        role: '角色',
        user: '用户'
    },
    // 页面 title
    pageTitle:{
        TireStep1:'单胎步序分析V1',
        TireStep2:'单胎步序分析V2'
    },
    // EventRecord 错误信息查询
    EventRecord: {
        topTitle: '故障报警查询',
        condition1: '设备:',
        condition2: '事件编号：',
        condition3: '类型：',
        condition4: '部套：',
        condition5: 'EM：',
        condition6: '持续时间：',
        selectPlacehoder: '请选择',
        timeStart: '开始时间',
        timeEnd: '截止时间',
        Clean: '清除',
        Search: '搜索',
        Export: '导出',
        tableTitle1: '设备',
        tableTitle2: '事件',
        tableTitle3: '事件内容',
        tableTitle4: '部套',
        tableTitle5: 'EM',
        tableTitle6: '类型',
        tableTitle7: '发生时间',
        tableTitle9: '结束时间',
        tableTitle8: '持续时间',
        monthTableTitle1:   '总产量',
            monthTableTitle2:   '总换料时间',
            monthTableTitle3:   '最优产量',
            monthTableTitle4:   '最劣产量',
        topTips: '事件记录，实时记录监控设备的所有运行事件信息。包括警告、错误、异常、停机、失败及其他信息。你可以通过时间、设备、工厂/车间、部套及事件类型等条件来筛选您需要的数据。',
        pickTime1: '最近4小时',
        pickTime2: '最近8小时',
        chartTitle: '错误信息排行 Top 3',
        chartTitle2: '报警信息排行 Top 3',
        machinesError: '设备近7天内无任何报警信息。',
        selectTimeError: '请选择查询时间'
    },
    // home首页
    home: {
        listTitle: '所有设备',
        seachPlacehoder: '搜索',
        All: '全部',
        online: '在线',
        offline: '离线',
        notConnected: '未接入',
        event: '事件'
    },
    // MachineDashBoard
    MachineDashBoard: {
        cascaderPlaceHoder: '切换',
        infoTitle1: '机器运行状态:',
        infoTitle2: '当前尺寸型号:',
        infoTitle3: '当前班组',
        infoTitle4: '连续运行时间:',
        infoTitle5: '当前生产率:',
        infoTitle6: '当前规格',
        infoTitle7: '同时最大输出圈数',
        stateDescribe1: '最近循环周期时间',
        stateDescribe2: '标准循环周期时间',
        stateDescribe3: '平均循环周期时间',
        stateDescribe4: '最佳循环周期时间',
        stateDescribe5: '班组生产计划',
        stateDescribe6: '预计生产率',
        stateDescribe7: '当前生产率',
        stateDescribe8: '同时最大输出圈数',
        class5: '圈',
        class1: '条胎',
        class2: '条胎/班',
        class3: '班组',
        class4: '套',
        maskOffline: '该机器已离线',
        maskNotConnected: '该机器尚未完成接入',
        maskNoproduction: '该机器已停止生产',
        state1: '运行中',
        state2: '待机',
        state3: '故障',
        state4: '停止',
        state5: '离线',
        state6: '未接入',
        labelTitle: '设备:',
        title1: '最新错误警报',
        title2: '设备日报',
        title3: '月产量',
        //各工位循环周期时间样式 新增
        cycletime: '各工位循环周期时间',
        station: '工位',
        current: '当前',
        last:'最近',
        best: '最佳',
        average: '平均',
        output: '产量输出',
        CC: '胎体',
        BT: '带束',
        SP: '成型',
        more: '更多',
        StartTime: '开始时间',
        EndTime: '结束时间',
        class6: '计算周期',
        pickTime1: '最近1小时',
        pickTime2: '最近3小时',
        pickTime3: '最近8小时',
        pickTime4: '最近1天',
        pickTime5: '最近2天',
        pickTime6: '最近30分钟',
        dataPickerMessage: '选择月份',
        //日期选择器手动输入的时间超过七天的提示语
        TimeMore7: '所选日期范围不能超过7天',
        noTimeList:'暂无设备日报'
    },
    // login
    login: {
        title1: '密码',
        title2: '验证码登录',
        placehoder1: '手机号码',
        placehoder2: '密码',
        placehoder3: '验证码',
        placehoder4: '新密码',
        placehoder5: '再次输入新密码',
        placehoder6: '账号',
        topTitleLeft: '赛象云',
        topTitleRight: '工业互联网',
        pttopTitleLeft: '中策半钢成型车间',
        pttopTitleRight: '设备互联网',
        login: '登录',
        error1: '请输入手机号',
        error2: '请输入密码',
        error3: '请确认您的手机号',
        error4: '密码长度需6~12个字符',
        error5: '请输入验证码',
        error6: '请再次输入密码',
        error7: '两次输入的密码不一致',
        error8: '请输入账号',
        wechatTitle: '二维码登录',
        getMsg: '获取短信',
        RsetMsg: '重置你的密码',
        next: '下一步',
        okBtn: '保存成功并登录',
        forgetPwd: '忘记密码',
        remember: '15天内自动登录',
        or: "或",
        wxTitle: "微信二维码登录",
        EnterpriseWxTitle: '企业微信二维码登录',
        dingTitle: '钉钉二维码登录',
        bindtitle1: '微信绑定赛象云账号',
        bindtitle2: '企业微信绑定赛象云账号',
        bindtitle3: '钉钉绑定赛象云账号',
        bindTips: '您的帐户未注册，请联系我们预约。',
        contactBtn: '»联系我们',
        wxTips: '使用微信二维码登录并关注官方账号',
        selectfactory: '请选择您要查看的工厂',
        scanbtn:'使用微信扫码登录',
        scanbtn2:'使用钉钉扫码登录'
    },
    // 大屏监控
    platform: {
        equipment: '设备',
        running: '运行中',
        fault: '故障中',
        tooling: '缺料',
        Reloading: '换料统计与预测',
        TotalTime: '总换料耗时 (最近3小时)',
        title: '全钢子午线轮胎车间',
        Events: '最新事件',
        Output: '产量统计与预测',
        TotalOutput: '总产量统计预测',
        EquipmentOutput: '设备产量统计 (最近3小时)',
        Average: '平均节拍时间 (最近3小时)',
        TotalTimes: '总耗时'
    },
    // 甘特图
    gantt: {
        placehoder1: '请选择',
        placehoder2: '搜索',
        labelTitle: '设备:',
        showBtn: '查看',
        StartTime: '开始时间',
        EndTime: '结束时间',
        dialogTitle: '选择数据显示图表',
        dialogCancel: '取消',
        dialogOk: '确定',
        exportBtn: '导出',
        dialogListTitle1: '所有',
        dialogListTitle2: '甘特图',
        error1: '请选择设备',
        error2: '请选择查询时间',
        error3: '最多选择64个事件编号',
        error4: '请选择事件编号',
        label1: '事件编号',
        label2: '部件',
        label3: '步骤',
        label4: '描述',
        label5: '开始时间',
        label6: '结束时间',
        label7: '持续时间',
        pickTime1: '最近1小时',
        pickTime2: '最近3小时',
        pickTime3: '最近8小时',
        pickTime4: '最近1天',
        pickTime5: '最近2天',
        error: '无数据',
        error5: '请选择查询步序',
        selectStep: '选择步序'
    },
    // 甘特图V2
    ganttv2:{
        collapse:'全部折叠',
        expand:'全部展开'
    },
    // 产量记录
    Production: {
        placehoder1: '请选择',
        labelTitle: '设备:',
        showBtn: '查看',
        StartTime: '开始时间',
        EndTime: '结束时间',
        radio1: '最近2班组',
        radio2: '最近3班组',
        radio3: '选择时间',
        placehoderLabel: '生胎数量',
        error1: '请选择设备',
        error2: '请选择查询时间',
        dialogTitle: '图表配置',
        dialogTitle2: 'X-轴',
        dialogLabel1: '时间间隔:',
        dialogLabel2: '起始时间:',
        dialogCancel: '取消',
        dialogOk: '确定',
        hourTitle: ' 小时',
        hoursTitle: ' 小时',
        shiftTitle: ' 班组',
        Ylabel: '产量',
        Ylabel2: '循环时间',
        tips: '生产时间'
    },
    // 步序时间图标
    StepCycleTime: {
        placehoder1: '请选择',
        labelTitle1: '设备:',
        placehoder2: 'All',
        labelTitle2: '步序:',
        showBtn: '查看',
        StartTime: '开始时间',
        EndTime: '结束时间',
        error1: '请选择查询设备',
        error2: '请选择查询日期',
        error3: '请选择查询步序',
        pickTime1: '昨天 ',
        pickTime2: '今天 ',
        shiftTitle: '班组',
        tableLeftTitle: '次数',
        tableRightTitle: '累计增长率',
        pickLable1: '昨天 第1班',
        pickLable2: '昨天 第2班',
        pickLable3: '昨天 第3班',
        pickLable4: '今天 第1班',
        pickLable5: '今天 第2班',
        pickLable6: '今天 第3班',
        tableTitle: '图表配置',
        tableLable1: '班组产量信息 ',
        tableLable2: '班组产量图表显示限位:',
        error4: '请输入数字',
        error5: '请输入正整数',
        error6: '请输入上限值',
        error7: '请输入下限值',
        dialogCancel: '取消',
        dialogOk: '确定',
        dialogTitle1: '时间范围内产量:',
        dialogTitle2: '整班产量:',
        dialogTitle3: '条胎',
        error8:'暂不支持查询7天以上的数据'
    },
    // 单个台步序时间（双甘特图）
    SingleTireStepAnalysis: {
        placehoder1: '请选择',
        labelTitle: '设备:',
        showBtn: '搜索',
        StartTime: '开始时间',
        EndTime: '结束时间',
        pickTime1: '最近2班组',
        pickTime2: '最近3班组',
        title: '部件故障'
    },
    // 节拍时间分布
    CycleDistribution: {
        error1: '查询失败!',
        tableTitle1: '开始时间',
        tableTitle2: '结束时间',
        tableTitle3: '总量',
        tableTitle4: '检查项',
        tabtitle: '天',
        tabtitle2: '班组'
    },
    // 换料统计
    ReloadingStatistics: {
        tableTitle1: '事件编号',
        tableTitle2: '事件',
        tableTitle3: '次数',
        innerTitle1: '详细',
        innerTitle2: '结束时间',
        innerTitle3: '当天产量',
        innerTitle4: '开始时间',
        innerTitle5: '持续时间',
        innerTitle6: '产出量',
        innerTitle7: '裁切量',
        frequency: '次',
        minute: '分钟',
        second: '秒',
        tires: '条胎',
        Total: '总计',
        export: '导出'
    },
    //模拟量分析
    AnalogValueAnalysis: {
        EventCode: '事件编码',
        Choosedate: '选择日期',
        Choosetime: '选择时间',
        show: '查看',
        equipment: '请先选择设备',
        selectEventCode: '请选择事件编码',
        pChoosedate: '请选择日期',
        pChoosetime: '请选择时间'
    },
    // 单机供料报表
    er02: {
        title1: '机台',
        title2: '产量',
        title3: '合计',
        Frequency: '发生次数',
        Occurred: '发生时间',
        LostTime: '消耗时间'
    },
    PF001: {
        ProductivityForecast: '产能预测',
        actual: '实际值',
        predicted: '预测值',
        noData: '查无数据',
        show: '显示',
        hours: '小时',
        productivity: '产能'
    },
    DetailedStepReport: {
        weeklyReport: '周报告',
        StepStatisticsReport: '大步序统计报表',
        NoData: '无数据'
    },
    // 车间详情信息
    WorkShopDashBoard: {
        label1: '车间:',
        dlTitle: '设备步序信息报告',
        dlTitle2: '换料统计报告',
        title3: '产能报告',
        exportBtn: '导出',
        monthlabel: '上个月 / 下个月',
        tabletitles1: '设备',
        listLabel1: '循环周期:',
        listLabel2: '生产率:',
        listLabel3: '班组',
        machineLifeCycle1: '制造中',
        machineLifeCycle2: '出厂前调试',
        machineLifeCycle3: '安装调试',
        machineLifeCycle4: '使用中',
        machineLifeCycle5: '维护维修',
        machineLifeCycle6: '技术改造',
        machineLifeCycle7: '已报废',
        faultAlarmStatisticsReport: '故障统计报告',
        weeklabel: '上一周 / 下一周',
        format: 'yyyy 第 WW 周',
        event: '事件',
        total: '总计',
        noEquipmentData: '暂无数据',
        noEquipmentTableMessage:'暂无可查看的数据',
        noEquipmentInFactory:'暂无可查看的设备',
        tooltipTitle1:'设备编号',
        tooltipTitle2:'通信编号',
        tooltipTitle3:'制造产号',
        tooltipTitle4:'生命周期',
        machineLifeList1:'制造中',
        machineLifeList2:'出厂前调试',
        machineLifeList3:'安装调试',
        machineLifeList4:'使用中',
        machineLifeList5:'维护维修中', 
        machineLifeList6:'技术改造中', 
        machineLifeList7:'已报废'
    },
    //部件故障报警查询
    PartsFaultAlarm: {
        part: '部件',
        show: '显示',
        Faults: '错误',
        Alarms: '警告',
        Resets: '重置',
        eventCode: '事件代码',
        Action: '动作',
        EndState: '终止状态',
        tableTitle1: '日期/时间',
        tableTitle2: '类型',
        tableTitle3: '代码/描述',
        tableTitle4: '设备',
        tableTitle5: '伺服轴',
        tableTitle6: '不包含代码/描述',
        search: '查询',
        all: '全部',
        enterText: '输入文字',
        StartTime: '开始时间',
        EndTime: '结束时间',
        except: '过滤',
        radio1: '过去一天',
        radio2: '过去一周',


    },
    //设备分时信息
    FailureTimeStatistics: {
        date: '日期',
        StartTime: '开始时间',
        EndTime: '结束时间',
        Production: '产量',
        FaultTimes: '故障次数',
        FailureTotalTime: '故障总时间',
        FailureEffectiveTime: '故障有效时间',
        factory: '工厂:'
    },
    //模拟量图表速览
    AnalogChartQuickView: {
        DashBoard: '仪表盘：',
        Choosedate: '日期',
        Choosetime: '时间',
    },
    //设备稼动率
    EquipmentUtilizationRate: {
        EURtitle: '设备稼动率',
        SelectExportData: '选择导出数据',
        ShiftInformation: '班次信息',
        ShiftProduction: '班产量',
        TimeLossDueToFailure: '班故障有效时间（分钟）',
        TimeLossDueToReloading: '班换料时间（分钟）',
        Production: '产量',
        FailureEffectiveTime: '故障有效时间',
        TimeOfReloading: '换料时间（分钟）',
        righttitle: '车间'
    },
    //设备详细步序报告
    EquipmentDetailedStepReport: {
        EDStitle: '设备详细步序报告',
    },
    //表单设计器
    fm: {
        formName: '表单设计器',
        components: {
            fields: {
                input: '单行文本',
                textarea: '多行文本',
                number: '计数器',
                radio: '单选框组',
                checkbox: '多选框组',
                time: '时间选择器',
                date: '日期选择器',
                rate: '评分',
                color: '颜色选择器',
                select: '下拉选择框',
                switch: '开关',
                slider: '滑块',
                text: '文字',
                blank: '自定义区域',
                fileupload: '文件',
                imgupload: '图片',
                editor: '编辑器',
                cascader: '级联选择器',
                table: '子表单',
                grid: '栅格布局',
                tabs: '标签页',
                divider: '分割线'
            },
            basic: {
                title: '基础字段',
            },
            advance: {
                title: '高级字段',
            },
            layout: {
                title: '布局字段',
            }
        },
        description: {
            containerEmpty: '从左侧拖拽来添加字段',
            configEmpty: '请添加字段',
            tableEmpty: '从左侧拖拽来添加字段',
            uploadJsonInfo: 'JSON格式如下，直接复制生成的json覆盖此处代码点击确定即可'
        },
        message: {
            copySuccess: '复制成功',
            validError: '表单数据校验失败'
        },
        //弹框
        actions: {
            import: '导入JSON',
            clear: '清空',
            preview: '提交表单',
            json: '生成JSON',
            code: '生成代码',
            getData: '获取数据',
            reset: '重置',
            copyData: '复制数据',
            cancel: '取 消',
            confirm: '确 定',
            addOption: '添加选项',
            addColumn: '添加列',
            addTab: '添加标签',
            upload: '点击上传',
            add: '添加'
        },
        // 右侧 表单属性与字段属性
        config: {
            // 表单属性
            form: {
                title: '表单属性',
                labelPosition: {
                    title: '标签对齐方式',
                    left: '左对齐',
                    right: '右对齐',
                    top: '顶部对齐'
                },
                labelWidth: '表单标签宽度',
                size: '组件尺寸',
                customClass: '自定义Class'
            },
            // 字段属性
            widget: {
                title: '字段属性',
                model: '字段标识',
                name: '标题',
                width: '宽度',
                height: '高度',
                size: '大小',
                labelWidth: '标签宽度',
                custom: '自定义',
                placeholder: '占位内容',
                layout: '布局方式',
                block: '块级',
                inline: '行内',
                contentPosition: '文案位置',
                left: '左侧',
                right: '右侧',
                center: '居中',
                showInput: '显示输入框',
                min: '最小值',
                max: '最大值',
                step: '步长',
                multiple: '是否多选',
                filterable: '是否可搜索',
                allowHalf: '允许半选',
                showAlpha: '支持透明度选择',
                showLabel: '是否显示标签',
                option: '选项',
                staticData: '静态数据',
                remoteData: '远端数据',
                remoteFunc: '远端方法',
                value: '值',
                label: '标签',
                childrenOption: '子选项',
                defaultValue: '默认值',
                showType: '显示类型',
                isRange: '是否为范围选择',
                isTimestamp: '是否获取时间戳',
                startPlaceholder: '开始时间占位内容',
                endPlaceholder: '结束时间占位内容',
                format: '格式',
                limit: '最大上传数',
                isQiniu: '使用七牛上传',
                tokenFunc: '获取七牛Token方法',
                imageAction: '图片上传地址',
                tip: '提示说明文字',
                action: '上传地址',
                defaultType: '绑定数据类型',
                string: '字符串',
                object: '对象',
                array: '数组',
                number: '数字',
                boolean: '布尔值',
                integer: '整数',
                float: '浮点数',
                url: 'URL地址',
                email: '邮箱地址',
                hex: '十六进制',
                gutter: '栅格间隔',
                columnOption: '列配置项',
                span: '栅格值',
                justify: '水平排列方式',
                justifyStart: '左对齐',
                justifyEnd: '右对齐',
                justifyCenter: '居中',
                justifySpaceAround: '两侧间隔相等',
                justifySpaceBetween: '两端对齐',
                align: '垂直排列方式',
                alignTop: '顶部对齐',
                alignMiddle: '居中',
                alignBottom: '底部对齐',
                type: '风格类型',
                default: '默认',
                card: '选项卡',
                borderCard: '卡片化',
                tabPosition: '选项卡位置',
                top: '顶部',
                // left: '左侧',
                // right: '右侧',
                bottom: '底部',
                tabOption: '标签配置项',
                tabName: '标签名称',
                customClass: '自定义Class',
                attribute: '操作属性',
                dataBind: '数据绑定',
                hidden: '隐藏',
                readonly: '完全只读',
                disabled: '禁用',
                editable: '文本框可输入',
                clearable: '显示清除按钮',
                arrowControl: '使用箭头进行时间选择',
                isDelete: '删除',
                isEdit: '编辑',
                showPassword: '显示密码',
                validate: '校验',
                required: '必填',
                patternPlaceholder: '填写正则表达式',
                newOption: '新选项',
                tab: '标签页',
                validatorRequired: '必须填写',
                validatorType: '格式不正确',
                validatorPattern: '格式不匹配'
            }
        },
        upload: {
            preview: '预览',
            edit: '替换',
            delete: '删除'
        }
    },
    // 半成品质量页面
    PQ: {
        tabPane1: '胎面',
        tabPane2: '零度带束层',
        tabPane3: '一号带束层',
        tabPane4: '二号带束层',
        tabPane5: '三号带束层',
        tabPane6: '四号带束层',
        tabPane7: '左子口',
        tabPane8: '右子口',
        tabPane9: '帘布',
        tabPane10: '胎侧',
        tabPane11: '内衬层',
        tabPane12: '垫胶',
        carName: '格栅车',
        total: '统计信息',
        treadInfo: {
            info1: '总数：',
            info2: '合格数量：',
            info3: '合格率：',
            info4: '不合格数量：',
            info5: '不合格率：',
            info6: '低于下公差数量：',
            info7: '低于下公差占比：',
            info8: '高于上公差数量：',
            info9: '高于上公差占比：'
        },
        Export: '导出',
        treadTableTitle: {
            title1: '日期/时间',
            title2: '长度(mm)',
            title3: '栅格车 车号',
            title4: '合格（标准差',
            title5: '<标准差-下公差',
            title6: '>标准差+上公差'
        },
        choseBtn: '选择格栅车',
        placeholder: '选择时间',
        yesterday: '昨天',
        threeDays: '最近三天'
    },
    account: {
        topTitle: '帐户信息',
        bottomTitle: '账户安全',
        infoLabels: {
            label1: '名称：',
            label2: '资料照片：',
            label3: '职位名称：',
            label4: '公司：',
            label5: '手机号码：',
            label6: '邮箱：',
            label7: '微信：',
            label8: '企业微信：',
            label9: '钉钉：'
        },
        editBtn: '编辑',
        saveBtn: '保存',
        changeBtn: '更改',
        bindBtn: '绑定',
        unbindBtn: '解绑',
        phoneTitle: '更改电话号码',
        placehode1: '新手机号码',
        placehode2: '验证码',
        placehode3: '邮箱地址',
        getBtn: '获取验证码',
        error1: '请输入你的手机号',
        error2: '请输入验证码',
        error3: '请输入你的邮箱地址',
        error4: '请输入正确邮箱地址',
        verBtn: '验证',
        bindTitle: '绑定邮箱地址',
        unbindTitle: '解绑邮箱地址',
        bindTitle2: '绑定微信',
        unbindTitle2: '解绑微信',
        bindTitle3: '企业微信二维码',
        unbindTitle3: '解绑企业微信',
        bindTitle4: '钉钉二维码',
        unbindTitle4: '解绑钉钉',
        unbindStrong: '解绑邮箱，你将:',
        unbindStrong2: '解绑微信，你将:',
        unbindStrong3: '解绑企业微信，你将:',
        unbindStrong4: '解绑钉钉，你将:',
        unbindtips: '不能及时收到通知',
        unbindtips2: "不能用微信登录",
        unbindtips3: "不能用企业微信登录",
        unbindtips4: "不能用钉钉登录",
        cofBtn: '确认',
        error: '不能为空',
        bindSuc: '绑定成功'
    },
    ganttV2: {
        factory: '工厂',
        workshop: '车间',
        machine: '设备',
        timeType1: '30分钟',
        timeType2: '1小时',
        downloadTitle: '导出按钮',
        downloadBtn1: '导出JPEG',
        downloadBtn2: '导出PDF',
        downloadBtn3: '导出PNG',
        downloadBtn4: '导出SVG',
        marketPublicTitle: '全钢成型车间'
    },
    // 设备参数日报
    Dailyequipment: {
        placehoder1: '请选择',
        labelTitle1: '设备:',
        tabPane1: '二次测长(带束侧)',
        tabPane2: '胎面滚压',
        tabPane3: '1号带束宽度',
        tabPane4: '2号带束宽度',
        tabPane5: '3号带束宽度',
        placehoder2: '选择月',
        placehoder3: '下载',
        noEquipmentData:'暂无可选设备',
        nodata: '初始化异常，请重新尝试',
        placehoder4: '无数据',
        changenodata: '您所选的无数据',
        tabData: '尚无本日数据，您可尝试查看昨天以前的数据',
        download: "下载"
    },
    // 车间报警统计
    WorkSHopAlarmStatistics: {
        placehoder1: '请选择',
        labelTitle1: '设备:',
        name: '车间报警统计',
        weeklabel: '上一周 / 下一周',
        format: 'yyyy 第 WW 周',
        event: '事件',
        total: '总计',
        exportBtn: '导出',
    },
    // 设备规格信息
    EquipmentSpecificationInformation: {
        name: '设备规格信息',
        exportBtn: '导出',
        format: 'yyyy 第 WW 周',
        weeklabel: '上一周 / 下一周',
        marketPublicTitle: '全钢成型车间',
        factory: '工厂',
        label1: '车间:',
        cascaderPlaceHoder: '切换',
        label2: '日期',
        label3: '时间',
        label4: '班组',
    },
    // 车间故障统计
    WorkShopFaultsStatistics: {
        title: '车间故障统计'
    },
    // 只针对于中策橡胶厂的底部文字
    ZcrubberEquiepmentIOT: {
        title: '由赛象云工业互联网提供技术支持'
    },
    // 班组名称
    shiftName:{
        Morning:'早',
        Middle:'中',
        Evening:'晚',
        A:'甲',
        B:'乙',
        C:'丙',
        D:'丁'
    },
    //新增设备平均效率对比
    EquipmentEfficiency:{
        chooseEquipment:'筛选设备',
        chooseRecipe:'筛选规格',
        error1:'请选择时间周期',
        error2:'请选择筛选设备',
        error3:'您选择的时间和设备范围内无任何规格数据',
        error4:'未记录规格',
        error5:'暂无设备',
        error6:'暂无调整人',
        tableTitle1:'设备',
        tableTitle2:'工位',
        tableTitle3:'胎体',
        tableTitle4:'带束',
        tableTitle5:'成型',
        tableTitle6:'设备',
        tableTitle7:'人工',
        tableTitle8:'滚压',
        tableTitle9:'规格',
        button1:'确认',
        chooseReviser:'筛选调整人',
        chooseItem:'筛选调整项'
    },
    //新增工艺参数对比
    CompareCraft:{
        chooseRecipe:'筛选配方',
        changePeople:'调整人',
        changeTime:'调整时间'
    },
    //新增工艺参数记录
    RecordCraft:{
        tableTitle1:'设备',
        tableTitle2:'配方',
        tableTitle3:'调整人',
        tableTitle4:'调整时间',
        tableTitle5:'调整项',
        tableTitle6:'调整值',
    },
    //新增带束位置信息
    BeamPositionInfo:{
        selectPlacehoder: '部套',
        error1: '请选择设备',
        error2: '请选择时间',
        error3: '请选择部套',
        error4: '时间范围不可超过24小时'
    },
    //VPN申请
    VpnApply:{
        title: 'VPN申请',
        searchCompany: '工厂名称',
        enterCompany: '输入工厂关键字',
        searchBox: '盒子名称',
        enterBox: '输入盒子关键字',
        Clean: '清除',
        search: '查询',
        company: '公司',
        box: '盒子',
        boxIp: '盒子IP',
        createTime: '创建时间',
        status: '状态',
        reviewer: '审核人',
        operation: '操作'
    },
    //VPN审核
    VpnReview:{
        title: 'VPN审核',
        searchUser: '申请人',
        enterUser: '输入关键字',
        search: '查询',
        company: '公司',
        box: '盒子',
        boxIp: '盒子IP',
        applyUser: '申请人',
        applyTime: '申请时间',
        operation: '操作'
    },
    //VPN添加
    VpnManage:{
        title: 'VPN管理',
        searchCompany: '工厂名称',
        enterCompany: '输入工厂关键字',
        searchBox: '盒子名称',
        enterBox: '输入盒子关键字',
        Clean: '清除',
        search: '查询',
        company: '公司',
        boxName: '盒子名称',
        boxType: '盒子类型',
        boxIP: '盒子IP',
        createUser: '创建人',
        createTime: '创建时间',
        credentials: '证书数量',
        operation: '操作',
        operationDelete: '删除',

        certificateLimitDate: '有效天数',
        notifyLimitDate: '提醒天数',
        certificateLimitNum: '证书上限',
        enterCertificateLimitNum: '输入盒子证书上限',
        enterCertificateLimitDate: '输入盒子有效天数',
        enterNotifyLimitDate: '输入盒子提醒天数',

        boxMsg: '盒子信息',
        belongMachine: '所属设备',
        add: '添加',
        cancel: '取消',
        reset: '重置',
        certificateMsg: '证书信息',
        applicant: '申请人',
        applyTime: '申请时间',
        applyIp: 'ip地址',
        reviewer: '审核人',
        reviewTime: '审核日期',
        loseTime: '过期日期',
        enterBoxName: '输入盒子关键字',
        chooseMachine: '请选择设备',
        enterBoxType: '请输入盒子类型'
    },
    ...zhLocale
}